// tslint:disable
/**
 * Ux
 * insightux admin api
 *
 * The version of the OpenAPI document: 0.62
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { MarketTypeFromJSON, MarketTypeToJSON, } from './';
export function GetSingleMarketResponseFromJSON(json) {
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'currency': !exists(json, 'currency') ? undefined : json['currency'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'referenceDate': !exists(json, 'referenceDate') ? undefined : new Date(json['referenceDate']),
        'marketType': !exists(json, 'marketType') ? undefined : MarketTypeFromJSON(json['marketType']),
    };
}
export function GetSingleMarketResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'id': value.id,
        'name': value.name,
        'currency': value.currency,
        'description': value.description,
        'referenceDate': value.referenceDate === undefined ? undefined : value.referenceDate.toISOString().substr(0, 10),
        'marketType': MarketTypeToJSON(value.marketType),
    };
}
